import { getRoutesDirections } from '@/data/libraries/Routes';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/ui/store/helperRedux';
import { changeLoginState, changeRegisterState } from '@/ui/store/slices/showModalsSlice';

import { IUserStore } from '@/domain/interfaces/IUser';

import { translate } from '@/domain/utils/translate';

import ColumnWraper from '@/ui/containers/Footer/Columns/ColumnWraper';
import OptionFooter from '@/ui/containers/Footer/Columns/OptionFooter';


/** Componente columna footer - Usuarios versión 2 */
const ColumnUsersV2 = (): JSX.Element => {
    /** Traemos la data el usuario para mostrarla */
    const userLogued: IUserStore = useAppSelector((state) => state.userState);

    /** Hook para generar una navegación dentro de la aplicación. */
    const navigate: NavigateFunction = useNavigate();

    /** Hook actualización estados Redux*/
    const dispatch = useAppDispatch();

    /** State Redux de estado de modales */
    const showModals = useAppSelector((state) => state.showModals);

    /** State redux activa login */
    const handleLogin = (): void => {
        !showModals.showLogin && dispatch(changeLoginState());
    }

    /** State redux activa registro */
    const handleRegister = (): void => {
        !showModals.showRegister && dispatch(changeRegisterState());
    }
    /** Rutas URLs */
    const routesDirections = getRoutesDirections();

    /** Muestra mis compras */
    const handleTraking = (): void => {
        if (userLogued.user.isLogued) {
            navigate(routesDirections.PURCHASES_ROUTE);
        } else {
            navigate(routesDirections.TRACKING_ROUTE);
        }
    }

    return (
        <ColumnWraper title={translate("footer.user_menu_title")}>
            {!userLogued.user.isLogued &&
                <>
                    <OptionFooter
                        title={translate("footer.login")}
                        hadleFunction={handleLogin}
                    />
                    <OptionFooter
                        title={translate("footer.register")}
                        hadleFunction={handleRegister}
                    />
                </>
            }
            <OptionFooter
                title={userLogued.user.isLogued ? translate("footer.purchases_title") : translate("footer.purchase_tracking_title")}
                hadleFunction={handleTraking}
            />
        </ColumnWraper>
    )
}

export default ColumnUsersV2;